<template>
    <modal ref="prompt" @opened="opened()">
        <form @submit.prevent="save">
            <div class="modal-body">
                <label class="form-label">{{ title }}</label>
                <input type="text" class="form-control" ref="input" v-model="value" />
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary" type="submit">{{ actionTitle }}</button>
            </div>
        </form>
    </modal>
</template>
<script>
export default {
    props: ["title", "action", "autoClose"],
    name: "prompt",
    data() {
        return {
            value: "",
            actionTitle: "",
            callback: null
        };
    },
    created() {
        this.actionTitle = this.action ? this.action : "Save";
    },
    methods: {
        save() {
            this.$emit("save", this.value);

            if (this.autoClose) {
                this.$refs.prompt.close();
            }

            if (this.callback) {
                this.callback(this.value, () => {
                    this.$refs.prompt.close();
                });
            }
        },
        open(value, callback) {
            this.value = value || "";
            this.callback = callback;
            this.$refs.prompt.open();
        },
        opened() {
            this.$refs.input.focus();
        },
        close() {
            this.$refs.prompt.close();
        }
    }
};
</script>
